"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retrieveStyle = void 0;

var _seamlessImmutable = require("seamless-immutable");

var _colors = _interopRequireDefault(require("../../scss/variables/_colors.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var retrieveStyle = function retrieveStyle(theme) {
  return {
    base: {
      textTransform: 'none',
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'base', 'backgroundColor']),
      borderRadius: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'base', 'borderRadius']),
      color: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'base', 'color']),
      fontFamily: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'fontFamily']),
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'base', 'fontSize'], (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'medium'])),
      '&:hover': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'base', 'hover', 'backgroundColor'])
      }
    },
    baseText: {
      textTransform: 'none',
      backgroundColor: _colors["default"].transparent,
      borderRadius: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'baseText', 'borderRadius']),
      color: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'baseText', 'color']),
      fontFamily: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'fontFamily']),
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'baseText', 'fontSize'], (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'medium'])),
      '&:hover': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'baseText', 'hover', 'backgroundColor'])
      }
    },
    baseOutlined: {
      textTransform: 'none',
      backgroundColor: _colors["default"].transparent,
      borderColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'baseOutlined', 'borderColor']),
      borderRadius: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'baseOutlined', 'borderRadius']),
      color: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'baseOutlined', 'color']),
      fontFamily: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'fontFamily']),
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'baseOutlined', 'fontSize'], (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'medium'])),
      '&:hover': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'baseOutlined', 'hover', 'backgroundColor'])
      }
    },
    secondary: {
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'secondary', 'backgroundColor']),
      color: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'secondary', 'color']),
      '&:hover': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'secondary', 'hover', 'backgroundColor'])
      }
    },
    secondaryText: {
      backgroundColor: _colors["default"].transparent,
      color: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'secondaryText', 'color']),
      '&:hover': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'secondaryText', 'hover', 'backgroundColor'])
      }
    },
    secondaryOutlined: {
      backgroundColor: _colors["default"].transparent,
      borderColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'secondaryOutlined', 'borderColor']),
      color: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'secondaryOutlined', 'color']),
      '&:hover': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'secondaryOutlined', 'hover', 'backgroundColor'])
      }
    },
    alternative: {
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'alternative', 'backgroundColor']),
      color: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'alternative', 'color']),
      '&:hover': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'alternative', 'hover', 'backgroundColor'])
      }
    },
    alternativeText: {
      backgroundColor: _colors["default"].transparent,
      color: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'alternativeText', 'color']),
      '&:hover': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'alternativeText', 'hover', 'backgroundColor'])
      }
    },
    alternativeOutlined: {
      backgroundColor: _colors["default"].transparent,
      borderColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'alternativeOutlined', 'borderColor']),
      color: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'alternativeOutlined', 'color']),
      '&:hover': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'alternativeOutlined', 'hover', 'backgroundColor'])
      }
    },
    gray: {
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'gray', 'backgroundColor']),
      color: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'gray', 'color']),
      '&:hover': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'gray', 'hover', 'backgroundColor'])
      }
    },
    grayText: {
      backgroundColor: _colors["default"].transparent,
      color: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'grayText', 'color']),
      '&:hover': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'grayText', 'hover', 'backgroundColor'])
      }
    },
    grayOutlined: {
      backgroundColor: _colors["default"].transparent,
      borderColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'grayOutlined', 'borderColor']),
      color: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'grayOutlined', 'color']),
      '&:hover': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'grayOutlined', 'hover', 'backgroundColor'])
      }
    },
    disabled: {
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'disabled', 'backgroundColor']),
      color: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'disabled', 'color'])
    },
    disabledText: {
      backgroundColor: _colors["default"].transparent,
      color: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'disabledText', 'color'])
    },
    disabledOutlined: {
      backgroundColor: _colors["default"].transparent,
      borderColor: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'disabledOutlined', 'borderColor']),
      color: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'disabledOutlined', 'color'])
    },
    small: {
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'small'])
    },
    large: {
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'large'])
    },
    lowercase: {
      textTransform: 'lowercase'
    },
    uppercase: {
      textTransform: 'uppercase'
    },
    labelFullWidth: {
      width: '100%'
    },
    loading: {
      color: (0, _seamlessImmutable.getIn)(theme, ['UTButton', 'loading', 'color']),
      position: 'absolute',
      left: 'calc(50% - 12px)'
    }
  };
};

exports.retrieveStyle = retrieveStyle;